import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter,RouterProvider,Route, Routes, BrowserRouter} from "react-router-dom"
import TodosPage from './components/TodosPage/TodosPage';
import ScheduleTodosPage from "./components/ScheduleTodosPage/ScheduleTodosPage"
import NotesPage from './components/NotesPage/NotesPage';
import DashBoardPage from './components/DashBoardPage/DashBoardPage';
import NoteEditPage from './components/NotesPage/NoteEditPage/NoteEditPage';
import NoteItemPage from './components/NotesPage/NoteItemPage/NoteItemPage';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/todos", element: <TodosPage /> },
      { path: "/schedule-todos", element: <ScheduleTodosPage/> },
      // { path: "/projects", element: <ProjectsPage /> },
      { path: "/notes", element: <NotesPage /> },
      { path: "/notes/newNote", element: <NoteEditPage /> },
      { path: "/notes/edit/:noteName", element: <NoteEditPage /> },
      {path: "/notes/:noteName", element: <NoteItemPage />},
      { path: "/", element: <DashBoardPage /> },
    ]
  }
])
const rootElement = document.getElementById('root') as Element
const root = ReactDOM.createRoot(rootElement);
root.render(
  // <BrowserRouter>
  //   <Routes>
  //     <Route path='/' element={<App />}>
  //       <Route path='todos' element={<TodosPage />} />
  //       <Route path='schedule-todos' element={<ScheduleTodosPage/>} />
  //       <Route path='projects' element={<ProjectsPage />} />
  //       <Route path='notes' element={<NotesPage />} >
  //         <Route path=':noteName' element={<TodosPage />} />
  //       </Route>
  //       <Route path='/profile' element={<ProfilePage />} />
  //     </Route>
  //   </Routes>
  // </BrowserRouter>
  
    <RouterProvider router={router}/>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
